import { render, staticRenderFns } from "./TheBottomTabBar.vue?vue&type=template&id=b9406fe8&scoped=true&lang=pug&"
import script from "./TheBottomTabBar.vue?vue&type=script&lang=js&"
export * from "./TheBottomTabBar.vue?vue&type=script&lang=js&"
import style0 from "./TheBottomTabBar.vue?vue&type=style&index=0&id=b9406fe8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9406fe8",
  null
  
)

export default component.exports